// import { GoogleTagManager } from "@next/third-parties/google"

import { gtmEnabled } from "@/lib/analytics/gtm-utils"
import { env } from "@/lib/env"

export function GtmScript({
  additionalContainerId,
  supportedBrowser = true,
}: {
  additionalContainerId?: string
  supportedBrowser?: boolean
}) {
  if (!supportedBrowser) {
    return null
  }

  const gtmAccounts = env("NEXT_PUBLIC_GTM_ACCOUNTS")?.split(",") || []
  // Currently not used - but for future if we need to ever pass in more GTM conatiner Id
  if (additionalContainerId) {
    gtmAccounts.push(additionalContainerId)
  }
  return (
    <>
      {gtmEnabled() && (
        <>
          {/* The container's GA4 tags hit these ~0.7 s in; resolve them early.
              Rendered as siblings of the script because web-app mounts this
              inside its own next/head, where a nested Head drops its children. */}
          <link rel="dns-prefetch" href="https://analytics.google.com" />
          <link rel="dns-prefetch" href="https://stats.g.doubleclick.net" />
          {/* Disable the click and scroll events that GTM auto generated by default */}
          {/*           
            Suggested by ChatGPT but does not seems to work
          <script
            dangerouslySetInnerHTML={{
              __html: `
                window['google_tag_manager'] = window['google_tag_manager'] || {};
                window['google_tag_manager'].autoEventEnabled = false;
                window['google_tag_manager'].config = {
                  historyChanges: false
                }
              `,
            }}
          /> */}
          {/*
            This does not work either
          <script
            dangerouslySetInnerHTML={{
              __html: `
                window.dataLayer = window.dataLayer || [];
                const originalPush = window.dataLayer.push;
                window.dataLayer.push = function(event) {
                  if (event && event.event === "gtm.historyChange-v2") {
                    return; // Suppress the event
                  }
                  else if (event && event.event === "scroll") {
                    return; // Suppress the event
                  }
                  else if (event && event.event === "gtm.scrollDepth") {
                    return; // Suppress the event
                  }
                  return originalPush.apply(this, arguments);
                }
              `,
            }}
          /> */}
          {gtmAccounts.map((gtmId, idx) => (
            // This does not work:
            // Recommend to use GoogleTagManager from:
            // https://nextjs.org/docs/app/building-your-application/optimizing/third-party-libraries#google-tag-manager
            // <GoogleTagManager key={idx} gtmId={gtmId} />

            // Google Tag Manager -- Mindtrip.ai
            // eslint-disable-next-line @next/next/next-script-for-ga
            <script
              id={`gtm-script:${idx}`}
              key={idx}
              // strategy="beforeInteractive" => This is only available if we use next/Script
              dangerouslySetInnerHTML={{
                __html: `
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${gtmId}');
              `,
              }}
            />
            // End Google Tag Manager
          ))}
        </>
      )}
    </>
  )
}
